export default Object.freeze({
  CLIENT: 'CLIENT',
  GROUP: 'GROUP',
  LOCATION: 'LOCATION',
})
